import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { IFeedbackReport } from '../../../utils/interfaces/feedback-report';
import {
  IFeedbackFilter,
  IReportFilter,
} from '../../../utils/interfaces/report-filter';
import { IResponse } from '../../../utils/interfaces/response';

@Injectable({
  providedIn: 'root',
})
export class FeedbackReportService {
  private readonly URI_API = environment.apiConfig.uri + 'FeedbackReport';

  constructor(private readonly httpClient: HttpClient) {}

  getFeedbackReport(
    filter: IFeedbackFilter
  ): Observable<IResponse<IFeedbackReport>> {
    return this.httpClient.post<IResponse<IFeedbackReport>>(
      `${this.URI_API}/feedback`,
      filter
    );
  }

  getFeedbackReportExcel(filter: IFeedbackFilter): Observable<any> {
    return this.httpClient
      .post(`${this.URI_API}/export`, filter, {
        responseType: 'blob',
      })
      .pipe(
        tap((response) => {
          this.saveDocument(filter, response, 'Feedback');
        })
      );
  }

  /**
   * @param filter filtro do relatório
   * @param b Blob do relatório
   * @param reportName Nome do relatório
   * @description Salva o documento em formato de Excel
   */
  private saveDocument(
    filter: IReportFilter,
    b: Blob,
    reportName: string
  ): void {
    const blob = new Blob([b], {
      type: 'application/vnd.ms-excel',
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Relatório de ${reportName} ${
      new Date(filter.startDate).getDate() < 9
        ? '0' + new Date(filter.startDate).getDate()
        : new Date(filter.startDate).getDate()
    }-${
      new Date(filter.startDate).getMonth() + 1 < 9
        ? '0' + (new Date(filter.startDate).getMonth() + 1)
        : new Date(filter.startDate).getMonth() + 1
    }-${new Date(filter.startDate).getFullYear()} - ${
      new Date(filter.finishDate).getDate() < 9
        ? '0' + new Date(filter.finishDate).getDate()
        : new Date(filter.finishDate).getDate()
    }-${
      new Date(filter.finishDate).getMonth() + 1 < 9
        ? '0' + (new Date(filter.finishDate).getMonth() + 1)
        : new Date(filter.finishDate).getMonth() + 1
    }-${new Date(filter.finishDate).getFullYear()}.xlsx`;

    a.click();
    window.URL.revokeObjectURL(url);
  }
}
